import { render, staticRenderFns } from "./OrdenTrabajoPaciente.vue?vue&type=template&id=3672e5de&scoped=true"
import script from "./OrdenTrabajoPaciente.vue?vue&type=script&lang=js"
export * from "./OrdenTrabajoPaciente.vue?vue&type=script&lang=js"
import style0 from "./OrdenTrabajoPaciente.vue?vue&type=style&index=0&id=3672e5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3672e5de",
  null
  
)

export default component.exports